/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {displayError} from '../../app/errorDisplayer';
import DataSourceDecoration from './DataSourceDecorationAdd.react';
import LoadingButton from '../../fw/LoadingButton.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import {LoadingLine} from '../../loadingLine/renderLoadingPanel.react';
import FRC from 'formsy-react-components';
const { Checkbox, CheckboxGroup } = FRC;
import {Form} from 'formsy-react';
import './DataSourceMatch.scss';
import types from '../../../common/model-api/types';
import config from '../../../common/config';

export const handlerName = "match";

export const messages = defineMessages({
    searchAll: {id: 'DataSourceMatch.searchAll.title', 'defaultMessage': 'Search all applications'},
    searchAllDescription: {id: 'DataSourceMatch.searchAll.description', 'defaultMessage': 'Including those added in the future.'},
    searchApp: {id: 'DataSourceMatch.searchApp.title', 'defaultMessage': 'Search in:'},
});

class DataSourceMatchAdd extends React.Component {

    static propTypes = {
        apply: PropTypes.func,
        dataSource: PropTypes.object,
        dataSourceToAdd: PropTypes.object,
        goBack: PropTypes.func,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.componentWillReceiveProps(props);

        this.state = {
            allSelected: true,
            isLoading: false,
            canSubmit: true,
        };
    }

    componentWillReceiveProps(props) {
        if (this.entityDef_id !== props.dataSourceToAdd.entityDef_id) {
            this.entityDef_id = props.dataSourceToAdd.entityDef_id;

            this.props.relay.setVariables({
                selectedEntityDef: true,
                entityDef_id: props.dataSourceToAdd.entityDef_id
            });
        }
    }

    onChange = (key, value, payload) => {
        if (value) {
            this.setState({
                allSelected: true
            });
        } else {
            this.setState({
                allSelected: false
            });
        }
    };

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    submit = async (data) => {
        this.setState({
            isLoading: true
        });

        let toCreate = {
            ...this.props.dataSourceToAdd
        };

        let rules = [];

        /* if we selected channelDefs, prepare match for them */
        if (!data.all) {
            for (let {node: channelEntityDef} of this.props.dataSource.screen.organisation.allUsedChildrenOfEntityDef.edges) {
                if (data.channelEntityDefs.findIndex((ced) => ced === channelEntityDef['realId']) !== -1) {

                    let rule = types['entitySelectionRules'].defaultValues(toCreate);
                    rule['entityDef_id'] = config.ENTITY_DEF_COMPANIES;
                    rule['channelDef_id'] = channelEntityDef['channelDef_id'];
                    rule['sourceDef_id'] = channelEntityDef['sourceDef_id'];

                    rules.push(rule);
                }
            }
        }

        if (rules.length === 0) {
            let rule = types['entitySelectionRules'].defaultValues(toCreate);
            rule['entityDef_id'] = config.ENTITY_DEF_COMPANIES;
            rules.push(rule);
        }

        toCreate['entitySelectionRules'] = rules;
        await this.props.apply(toCreate);

        this.setState({
            isLoading: false
        });
    };

    render() {
        let dataSourceToAdd = this.props.dataSourceToAdd;
        let dataSource = this.props.dataSource;

        try {
            return (
                <DataSourceDecoration
                    dataSource={dataSource}
                    dataSourceToAdd={dataSourceToAdd}
                    goBack={this.props.goBack}
                >

                    <div style={{padding: '2em'}}>
                        {dataSource && dataSource.screen && dataSource.screen.organisation && dataSource.screen.organisation.allUsedChildrenOfEntityDef ?
                            <div>
                                <FormattedMessage defaultMessage="Search will be performed in these apps:" id="DataSourceMatch.description" />


                                <Form
                                    className="DataSourceMatch"
                                    onInvalid={this.disableButton}
                                    onSubmit={this.submit}
                                    onValid={this.enableButton}
                                >
                                    <Checkbox
                                        help={this.props.intl.formatMessage(messages.searchAllDescription)}
                                        label={this.props.intl.formatMessage(messages.searchAll)}
                                        name="all"
                                        onChange={this.onChange}
                                        value
                                    />

                                    <div className="spacer"></div>

                                    <div className={this.state.allSelected ? 'disabled' : null}>
                                        <CheckboxGroup
                                            disabled={this.state.allSelected}
                                            label={this.props.intl.formatMessage(messages.searchApp)}
                                            name="channelEntityDefs"
                                            options={dataSource.screen.organisation.allUsedChildrenOfEntityDef.edges.map((node, idx) => {
                                                return ({
                                                    value: node.node.realId,
                                                    label: node.node.channelDef.name + " > " + node.node.sourceDef.name,
                                                    disabled: this.state.allSelected
                                                });
                                            })}
                                            required={!this.state.allSelected}
                                            value={[]}
                                        />
                                    </div>

                                    <LoadingButton
                                        className="btn btn-default"
                                        disabled={!this.state.canSubmit}
                                        isLoading={this.state.isLoading}
                                        type="submit">
                                        <span aria-hidden="true" className="fa fa-plus"></span>{" "}<FormattedMessage defaultMessage="Add" id="screenSettings.addThisQuery" />
                                    </LoadingButton>
                                </Form>
                            </div>
                            :
                            <LoadingLine />
                        }
                    </div>
                </DataSourceDecoration>
            );
        } catch (e) {
            displayError(e);
            return (<div>Error</div>);
        }
    }
}

export default Relay.createContainer(injectIntl(DataSourceMatchAdd), {
    initialVariables: {
        selectedEntityDef: false,
        entityDef_id: null,
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    primaryEntityDef {
                        id,
                        realId,
                        name
                    },
                    channelDefs {
                        id,
                        name,
                        icon
                    },
                    screen {
                        id,
                        organisation {
                            id,
                            allUsedChildrenOfEntityDef(first: 100, entityDef_id: $entityDef_id) @include(if: $selectedEntityDef) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        entityDef_id,
                                        entityDef {
                                            id,
                                            realId,
                                            name
                                        },
                                        sourceDef_id,
                                        sourceDef {
                                            id,
                                            realId,
                                            name
                                        },
                                        channelDef_id,
                                        channelDef {
                                            id,
                                            realId,
                                            name,
                                            icon
                                        }
                                    }
                                }
                            },
                        }
                    }
                }`;
        }
    }
});
